export default __webpack_public_path__ + "static/media/web-development.18c9f742.svg";